<template>
  <v-card outlined rounded id="trailer-identifier-card">
    <v-card-title>
      <v-icon class="mr-2" color="primary">mdi-truck-trailer</v-icon>
      <span data-testid="trailer-identifier-card-value" class="subtitle-1">{{ trailerIdentifier.value }}</span>
      <v-spacer/>
      <Icon
        v-if="showCrud"
        dataTestId="trailer-identifier-edit-button"
        icon="mdi-pencil"
        iconColor="success"
        :tooltipText="$t('edit')"
        tabindex="0"
        @icon-clicked="$emit('click:edit', trailerIdentifier)"
        elementId="edit-trailer-identifier"/>
      <Icon
        v-if="showCrud"
        dataTestId="trailer-identifier-delete-button"
        icon="mdi-delete-forever"
        iconColor="error"
        :tooltipText="$t('delete')"
        tabindex="0"
        @icon-clicked="openDeleteDialog"
        elementId="delete-trailer-identifier"/>
    </v-card-title>
    <v-card-text class="mt-n2">
      <v-container fluid grid-list-sm>
        <v-row no-gutters class="ml-n2">
          <v-col cols="12" v-if="vehicleTypeName">
            <span class="font-weight-medium">{{ $t('vehicleType') }}:</span> {{ vehicleTypeName }}
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>
    <v-dialog width="400px" v-model="openDialog">
      <ConfirmDialog
        v-if="openDialog"
        :title="$t('deleteTrailerIdentifier')"
        :body="$t('deleteTrailerIdentifierBody')"
        @confirm="deleteTrailerIdentifier"
        @cancel="openDialog = ''"/>
    </v-dialog>
  </v-card>
</template>

<script>
import { VehicleType } from '@/utils/Enumerations'

export default {
  name: 'TrailerIdentifierCard',

  components: {
    ConfirmDialog: () => import('@/components/helper/ConfirmDialog.vue'),
    Icon: () => import('@/components/helper/Icon.vue')
  },

  props: {
    trailerIdentifier: {
      type: Object,
      required: true
    },
    showCrud: {
      type: Boolean,
      default: true
    }
  },

  data: () => ({
    openDialog: ''
  }),

  computed: {
    vehicleTypeName () {
      if (this.trailerIdentifier.vehicleType == null) return null
      return VehicleType.fromInt(this.trailerIdentifier.vehicleType)
    }
  },

  methods: {
    openDeleteDialog () {
      this.openDialog = 'delete'
    },

    deleteTrailerIdentifier () {
      this.$emit('click:delete', this.trailerIdentifier)
      this.openDialog = ''
    }
  }
}
</script>
